export default "__VITE_ASSET__CuacJYdI__"